import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingCenteredImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 2.5h16V0H0zM0 16h16v-2.5H0zM16 4.5H0v7h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingCenteredImage
